import coreAPIService from './coreAPIService';
import { CTW_API_ENDPOINT } from '../utils';
import { commonApiResponse } from '../interfaces/response';

export interface DataSourceEvent {
    id: number;
    name: string;
}

export interface Milestone {
    milestoneId: number;
    milestoneName: string;
    milestoneNo: number;
    milestonePositioner: string;
}

export interface MappedEvent {
    milestoneId: string;
    milestoneName: string;
    milestonePositioner: string;
    convEventName: string;
    value: number;
    currency: string;
}

export interface ClientRow {
    clientId: string;
    subdomain: string;
    wabaNumber: string;
    conversionApiEnabled: boolean;
    datasetAvailable: boolean;
    datasetId: string | null;
    datasetName: string | null;
    botId: string | null;
    botName: string | null;
    milestones: Milestone[];
    mappedEvents: MappedEvent[];
}

export interface OrgOptionsResponse {
    meta: { status: boolean; message: string; code: number; newToken?: string };
    data: {
        dataSourceEvents: DataSourceEvent[];
        clients: ClientRow[];
    };
}

export interface MappingItem {
    event_name: string;
    milestone_id: string;
    milestone_name: string;
    value?: number;
    currency?: string;
    value_type?: string;
    value_min?: number;
    value_max?: number;
}

export interface MappingPayload {
    data: MappingItem[];
}

const eventMappingService = {
    fetchOrgOptions: async (orgId: string) => {
        return await coreAPIService.get<OrgOptionsResponse>(
            CTW_API_ENDPOINT,
            `v2/event-mapping/org/options/${orgId}`
        );
    },

    toggleConversionApi: async (clientId: string, enabled: boolean) => {
        return await coreAPIService.post<commonApiResponse>(
            CTW_API_ENDPOINT,
            `v2/event-mapping/clients/${clientId}/conversion-api`,
            { button: enabled }
        );
    },

    saveEventMapping: async (clientId: string, payload: MappingPayload) => {
        return await coreAPIService.post<commonApiResponse>(
            CTW_API_ENDPOINT,
            `v2/event-mapping/clients/${clientId}/mappings`,
            payload
        );
    },
};

export default eventMappingService;
